<template>
    <div class="UniversityForm relative space-y-5">
        <CFormGroup label="Názov vysokej školy">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.school"
                @update:model-value="update({ school: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Mesto">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.address"
                @update:model-value="update({ address: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Študijný odbor">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.specialistation"
                @update:model-value="update({ specialistation: $event })"
            />
        </CFormGroup>

        <CFormGroup label="Titul">
            <CFormInput
                :disabled="disabled"
                :has-suffix="$attrs['hasSuffix']"
                :suffix-icon="$attrs['suffixIcon']"
                :model-value="modelValue.degree"
                @update:model-value="update({ degree: $event })"
            />
        </CFormGroup>

        <YearsRangeInput
            :disabled="disabled"
            end-label="Rok ukončenia štúdia"
            :end-year="modelValue.endYear"
            start-label="Rok začatia štúdia"
            :start-year="modelValue.startYear"
            @change="update($event)"
        />

        <CFormGroup label="Popis">
            <CWysiwyg
                :allowed-buttons="['back', 'forward', 'bold', 'italic', 'strike', 'orderedList', 'bulletList']"
                :disabled="disabled"
                :model-value="modelValue.desc"
                @update:model-value="update({ desc: $event })"
            />
        </CFormGroup>
    </div>
</template>

<script setup lang="ts">
import type { School } from '#shared/types/User'

const props = defineProps({
    modelValue: {
        type: Object as () => School,
        default: () => ({}) as School
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue'])

function update(change: { [key in keyof School]: any }) {
    emit('update:modelValue', { ...props.modelValue, ...change })
}
</script>